import React from 'react'
import DenaliLogo from '../../../../../apps/aiApp/Assistant/common/DenaliLogo'

function AIEnabledTag () {
  return (
    <div
      className='flex gap-sm radius-sm'
      style={{
        borderColor: 'var(--color-warning-700)',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: 'var(--padding-xs) var(--padding-sm)',
        backgroundColor: 'var(--color-ai-500)',
        color: 'var(--color-contrast-ai-500)'
      }}
    >
      <DenaliLogo flat size='16px' />
      <span>AI Enabled</span>
    </div>
  )
}

export default AIEnabledTag
